import { CampaignType } from 'generated-graphql/types';
import { getCampaignCreationTemplateVariables } from 'pages/CampaignCreation/utils/getCampaignCreationTemplateVariables';
import Yup from 'utils/validation';
import { ERROR_MESSAGES } from 'core/constants/errorMessages';
import { validateTemplatedInputVariables } from 'core/utils/validators/validateTemplatedInputVariables';
import { GetCampaignInitialValidationObject } from 'modules/campaign-creation/utils/getCampaignCreationSetupValidation';

export type GetCampaignCreationEmailValidationProps = {
  campaignType: CampaignType;
  validationObject: GetCampaignInitialValidationObject;
};

export const getCampaignCreationEmailValidation = ({
  campaignType,
  validationObject
}: GetCampaignCreationEmailValidationProps) => {
  // TODO: Fix this type
  const variables = getCampaignCreationTemplateVariables(campaignType as any);
  return Yup.object().shape({
    ...validationObject,
    templateId: Yup.string().nullable(),
    customTemplatedMessageCharactersCount: Yup.number().nullable(),
    customTemplatedSubjectLine: Yup.string().nullable(),
    customTemplatedMessage: Yup.string()
      .required('Enter your opening message')
      .test(
        'variable-validation',
        ERROR_MESSAGES.templatedInputVariableMustBeValid,
        (value) => {
          if (!value) return true;

          return validateTemplatedInputVariables({
            variables,
            value
          });
        }
      )
  });
};
